import gql from 'graphql-tag';
import * as Urql from 'urql';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
};

export type AccountDetailInfo = {
  __typename?: 'AccountDetailInfo';
  AccountNumber: Scalars['String']['output'];
  AmericanOnTaxSystem?: Maybe<Scalars['Boolean']['output']>;
  AnnualIncome: Scalars['Int']['output'];
  BankCode: Scalars['String']['output'];
  Birthday?: Maybe<Scalars['String']['output']>;
  BranchCode: Scalars['String']['output'];
  BuildingNameRoomNumber?: Maybe<Scalars['String']['output']>;
  CityCounty: Scalars['String']['output'];
  Department?: Maybe<Scalars['String']['output']>;
  DepositForm: Scalars['Int']['output'];
  FATCAAgreement?: Maybe<Scalars['Boolean']['output']>;
  FATCAOath?: Maybe<Scalars['Boolean']['output']>;
  FinancialAssets: Scalars['Int']['output'];
  FirstName: Scalars['String']['output'];
  FirstNameKana: Scalars['String']['output'];
  HomePhoneNumber?: Maybe<Scalars['String']['output']>;
  ITIN?: Maybe<Scalars['String']['output']>;
  IncomeForm: Array<Maybe<Scalars['Int']['output']>>;
  InsiderBoardMemberFirstName?: Maybe<Scalars['String']['output']>;
  InsiderBoardMemberLastName?: Maybe<Scalars['String']['output']>;
  InvestmentExperiences: Array<Maybe<Scalars['Int']['output']>>;
  InvestmentPolicy: Scalars['Int']['output'];
  InvestmentPurposes: Array<Maybe<Scalars['Int']['output']>>;
  LastName: Scalars['String']['output'];
  LastNameKana: Scalars['String']['output'];
  ListedCompanyCheck: Scalars['Boolean']['output'];
  ListedCompanyName?: Maybe<Scalars['String']['output']>;
  ListedCompanyPost?: Maybe<Scalars['Int']['output']>;
  MailAddress?: Maybe<Scalars['String']['output']>;
  MobilePhoneNumber: Scalars['String']['output'];
  Nationality: Scalars['Int']['output'];
  OutSidePost?: Maybe<Scalars['String']['output']>;
  Post?: Maybe<Scalars['String']['output']>;
  PostCode: Scalars['String']['output'];
  Prefecture: Scalars['String']['output'];
  Profession: Scalars['Int']['output'];
  RetirementDate?: Maybe<Scalars['String']['output']>;
  SSN?: Maybe<Scalars['String']['output']>;
  Sex?: Maybe<Scalars['Int']['output']>;
  TownStreetAddress?: Maybe<Scalars['String']['output']>;
  WorkPhoneNumber?: Maybe<Scalars['String']['output']>;
  Workplace?: Maybe<Scalars['String']['output']>;
};

export type AccountInfo = {
  __typename?: 'AccountInfo';
  Account: Scalars['String']['output'];
  ChangedPassword: Scalars['Boolean']['output'];
  DepositAmount: Scalars['String']['output'];
  LastLoginDateTime?: Maybe<Scalars['String']['output']>;
  MarginAmount: Scalars['String']['output'];
};

export type AddressInfo = {
  __typename?: 'AddressInfo';
  CityCounty?: Maybe<Scalars['String']['output']>;
  Prefecture?: Maybe<Scalars['String']['output']>;
  TownStreetAddress?: Maybe<Scalars['String']['output']>;
};

export type AgreeDocumentParam = {
  Types: Array<InputMaybe<Scalars['Int']['input']>>;
};

export type AgreementDocumentInfo = {
  __typename?: 'AgreementDocumentInfo';
  Read: Scalars['Boolean']['output'];
  Type: Scalars['Int']['output'];
  URL: Scalars['String']['output'];
};

export type AgreementDocumentList = {
  __typename?: 'AgreementDocumentList';
  Data?: Maybe<Array<Maybe<AgreementDocumentInfo>>>;
};

export type ApplicationDetailInfo = {
  __typename?: 'ApplicationDetailInfo';
  ID: Scalars['String']['output'];
  LatestApplicationDateTime: Scalars['String']['output'];
  Status: Scalars['Int']['output'];
  Symbol: Scalars['String']['output'];
  SymbolName: Scalars['String']['output'];
  TotalApplicationQuantity: Scalars['Int']['output'];
  TotalPurchaseQuantity: Scalars['Int']['output'];
};

export type ApplicationInfo = {
  __typename?: 'ApplicationInfo';
  ID: Scalars['String']['output'];
  LatestApplicationDateTime: Scalars['String']['output'];
  Status: Scalars['Int']['output'];
  Symbol: Scalars['String']['output'];
  SymbolName: Scalars['String']['output'];
  TotalApplicationQuantity: Scalars['Int']['output'];
  TotalPurchaseQuantity: Scalars['Int']['output'];
};

export type ApplicationList = {
  __typename?: 'ApplicationList';
  Data?: Maybe<Array<Maybe<ApplicationInfo>>>;
  TotalCount: Scalars['Int']['output'];
};

export type ApplySymbolParam = {
  Quantity: Scalars['Int']['input'];
  Symbol: Scalars['String']['input'];
};

export type BrokerInfo = {
  __typename?: 'BrokerInfo';
  BranchCode?: Maybe<Scalars['String']['output']>;
  BranchName?: Maybe<Scalars['String']['output']>;
  BrokerCode?: Maybe<Scalars['String']['output']>;
  BrokerName?: Maybe<Scalars['String']['output']>;
};

export type ChangeAccountInfoParam = {
  AccountNumber?: InputMaybe<Scalars['String']['input']>;
  AmericanOnTaxSystem?: InputMaybe<Scalars['Boolean']['input']>;
  AnnualIncome?: InputMaybe<Scalars['Int']['input']>;
  BankCode?: InputMaybe<Scalars['String']['input']>;
  Birthday?: InputMaybe<Scalars['String']['input']>;
  BranchCode?: InputMaybe<Scalars['String']['input']>;
  BuildingNameRoomNumber?: InputMaybe<Scalars['String']['input']>;
  CityCounty?: InputMaybe<Scalars['String']['input']>;
  Department?: InputMaybe<Scalars['String']['input']>;
  DepositForm?: InputMaybe<Scalars['Int']['input']>;
  FATCAAgreement?: InputMaybe<Scalars['Boolean']['input']>;
  FATCAOath?: InputMaybe<Scalars['Boolean']['input']>;
  FinancialAssets?: InputMaybe<Scalars['Int']['input']>;
  FirstName?: InputMaybe<Scalars['String']['input']>;
  FirstNameKana?: InputMaybe<Scalars['String']['input']>;
  HomePhoneNumber?: InputMaybe<Scalars['String']['input']>;
  ITIN?: InputMaybe<Scalars['String']['input']>;
  IncomeForm?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  InsiderBoardMemberFirstName?: InputMaybe<Scalars['String']['input']>;
  InsiderBoardMemberLastName?: InputMaybe<Scalars['String']['input']>;
  InvestmentExperiences?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  InvestmentPolicy?: InputMaybe<Scalars['Int']['input']>;
  InvestmentPurposes?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  LastName?: InputMaybe<Scalars['String']['input']>;
  LastNameKana?: InputMaybe<Scalars['String']['input']>;
  ListedCompanyCheck?: InputMaybe<Scalars['Boolean']['input']>;
  ListedCompanyName?: InputMaybe<Scalars['String']['input']>;
  ListedCompanyPost?: InputMaybe<Scalars['Int']['input']>;
  MailAddress?: InputMaybe<Scalars['String']['input']>;
  MobilePhoneNumber?: InputMaybe<Scalars['String']['input']>;
  Nationality?: InputMaybe<Scalars['Int']['input']>;
  OutSidePost?: InputMaybe<Scalars['String']['input']>;
  Post?: InputMaybe<Scalars['String']['input']>;
  PostCode?: InputMaybe<Scalars['String']['input']>;
  Prefecture?: InputMaybe<Scalars['String']['input']>;
  Profession?: InputMaybe<Scalars['Int']['input']>;
  RetirementDate?: InputMaybe<Scalars['String']['input']>;
  SSN?: InputMaybe<Scalars['String']['input']>;
  Sex?: InputMaybe<Scalars['Int']['input']>;
  TownStreetAddress?: InputMaybe<Scalars['String']['input']>;
  WorkPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  Workplace?: InputMaybe<Scalars['String']['input']>;
};

export type ChangeAccountInfoResult = {
  __typename?: 'ChangeAccountInfoResult';
  Code: Scalars['Int']['output'];
  Message?: Maybe<Scalars['String']['output']>;
  WithEKYC?: Maybe<Scalars['Boolean']['output']>;
};

export type ChangePasswordParam = {
  CurrentPassword: Scalars['String']['input'];
  NewPassword: Scalars['String']['input'];
};

export type DateTimeInfo = {
  __typename?: 'DateTimeInfo';
  Current?: Maybe<Scalars['String']['output']>;
};

export type ExecuteResult = {
  __typename?: 'ExecuteResult';
  AdditionalMessage?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Code: Scalars['Int']['output'];
  Message?: Maybe<Scalars['String']['output']>;
};

export type InquiryParam = {
  Content?: InputMaybe<Scalars['String']['input']>;
};

export type IssuanceDocument = {
  __typename?: 'IssuanceDocument';
  Data: Scalars['String']['output'];
};

export type IssuanceDocumentInfo = {
  __typename?: 'IssuanceDocumentInfo';
  DisplayName: Scalars['String']['output'];
  FileName: Scalars['String']['output'];
  ID: Scalars['String']['output'];
  IssueDate: Scalars['String']['output'];
};

export type IssuanceDocumentList = {
  __typename?: 'IssuanceDocumentList';
  Data?: Maybe<Array<Maybe<IssuanceDocumentInfo>>>;
  TotalCount: Scalars['Int']['output'];
};

export type LoginParam = {
  Account: Scalars['String']['input'];
  Password: Scalars['String']['input'];
};

export type LoginResult = {
  __typename?: 'LoginResult';
  Code: Scalars['Int']['output'];
  Message?: Maybe<Scalars['String']['output']>;
  PhoneNumber?: Maybe<Scalars['String']['output']>;
  ProvisionalToken?: Maybe<Scalars['String']['output']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  AgreeDocument?: Maybe<ExecuteResult>;
  ApplySymbol?: Maybe<ExecuteResult>;
  ChangeAccountInfo?: Maybe<ChangeAccountInfoResult>;
  ChangePassword?: Maybe<ExecuteResult>;
  Inquiry?: Maybe<ExecuteResult>;
  Login?: Maybe<LoginResult>;
  Logout?: Maybe<ExecuteResult>;
  OpenAccount?: Maybe<ExecuteResult>;
  ReadNotification?: Maybe<ExecuteResult>;
  ReissuePassword?: Maybe<ReissuePasswordResult>;
  SMSCertificate?: Maybe<SmsCertificateResult>;
  SendSMS?: Maybe<SendSmsResult>;
};


export type MutationAgreeDocumentArgs = {
  input?: InputMaybe<AgreeDocumentParam>;
};


export type MutationApplySymbolArgs = {
  input?: InputMaybe<ApplySymbolParam>;
};


export type MutationChangeAccountInfoArgs = {
  input?: InputMaybe<ChangeAccountInfoParam>;
};


export type MutationChangePasswordArgs = {
  input?: InputMaybe<ChangePasswordParam>;
};


export type MutationInquiryArgs = {
  input?: InputMaybe<InquiryParam>;
};


export type MutationLoginArgs = {
  input?: InputMaybe<LoginParam>;
};


export type MutationOpenAccountArgs = {
  input?: InputMaybe<OpenAccountParam>;
};


export type MutationReadNotificationArgs = {
  input?: InputMaybe<ReadNotificationParam>;
};


export type MutationReissuePasswordArgs = {
  input?: InputMaybe<ReissuePasswordParam>;
};


export type MutationSmsCertificateArgs = {
  input?: InputMaybe<SmsCertificateParam>;
};


export type MutationSendSmsArgs = {
  input?: InputMaybe<SendSmsParam>;
};

export type NotificationDetailInfo = {
  __typename?: 'NotificationDetailInfo';
  ConfirmDateTime?: Maybe<Scalars['String']['output']>;
  Confirmed?: Maybe<Scalars['Boolean']['output']>;
  Contents: Scalars['String']['output'];
  DeliveryTarget: Scalars['Int']['output'];
  DeliveryType: Scalars['Int']['output'];
  ID: Scalars['String']['output'];
  PublishStartDate: Scalars['String']['output'];
  Title: Scalars['String']['output'];
};

export type NotificationInfo = {
  __typename?: 'NotificationInfo';
  Confirmed?: Maybe<Scalars['Boolean']['output']>;
  DeliveryTarget: Scalars['Int']['output'];
  DeliveryType: Scalars['Int']['output'];
  ID: Scalars['String']['output'];
  PublishStartDate: Scalars['String']['output'];
  Title: Scalars['String']['output'];
};

export type NotificationList = {
  __typename?: 'NotificationList';
  Data?: Maybe<Array<Maybe<NotificationInfo>>>;
  TotalCount: Scalars['Int']['output'];
};

export type OpenAccountParam = {
  AccountNumber: Scalars['String']['input'];
  AgeConfirmation: Scalars['Boolean']['input'];
  AmericanOnTaxSystem?: InputMaybe<Scalars['Boolean']['input']>;
  AnnualIncome: Scalars['Int']['input'];
  AntiSocialForcesCheckAgreement: Scalars['Boolean']['input'];
  BankCode: Scalars['String']['input'];
  Birthday: Scalars['String']['input'];
  BranchCode: Scalars['String']['input'];
  BuildingNameRoomNumber?: InputMaybe<Scalars['String']['input']>;
  CityCounty: Scalars['String']['input'];
  Department: Scalars['String']['input'];
  DepositForm: Scalars['Int']['input'];
  DistributionStatementAgreement: Scalars['Boolean']['input'];
  ElectronicDocumentAgreement: Scalars['Boolean']['input'];
  ElectronicDocumentAgreementDateTime?: InputMaybe<Scalars['String']['input']>;
  FATCAAgreement?: InputMaybe<Scalars['Boolean']['input']>;
  FATCAOath?: InputMaybe<Scalars['Boolean']['input']>;
  FinancialAssets: Scalars['Int']['input'];
  FinancialIntermediary?: InputMaybe<Scalars['Int']['input']>;
  FinancialIntermediaryCenter?: InputMaybe<Scalars['Int']['input']>;
  FinancialIntermediaryExplanation: Scalars['Boolean']['input'];
  FinancialIntermediaryInvitation: Scalars['Boolean']['input'];
  FirstName: Scalars['String']['input'];
  FirstNameKana: Scalars['String']['input'];
  HomePhoneNumber?: InputMaybe<Scalars['String']['input']>;
  IDConfirmation: Scalars['Boolean']['input'];
  ITIN?: InputMaybe<Scalars['String']['input']>;
  IncomeForm: Array<InputMaybe<Scalars['Int']['input']>>;
  InformationSharingAgreement: Scalars['Boolean']['input'];
  InsiderBoardMemberFirstName?: InputMaybe<Scalars['String']['input']>;
  InsiderBoardMemberLastName?: InputMaybe<Scalars['String']['input']>;
  InvestmentExperiences: Array<InputMaybe<Scalars['Int']['input']>>;
  InvestmentPolicy: Scalars['Int']['input'];
  InvestmentPurposes: Array<InputMaybe<Scalars['Int']['input']>>;
  LastName: Scalars['String']['input'];
  LastNameKana: Scalars['String']['input'];
  ListedCompanyCheck: Scalars['Boolean']['input'];
  ListedCompanyName?: InputMaybe<Scalars['String']['input']>;
  ListedCompanyPost?: InputMaybe<Scalars['Int']['input']>;
  MailAddress?: InputMaybe<Scalars['String']['input']>;
  ManagerCode?: InputMaybe<Scalars['String']['input']>;
  MobilePhoneNumber: Scalars['String']['input'];
  Nationality: Scalars['Int']['input'];
  OutSidePost?: InputMaybe<Scalars['String']['input']>;
  PEPsConfirmation: Scalars['Boolean']['input'];
  Post: Scalars['String']['input'];
  PostCode: Scalars['String']['input'];
  PreContractAgreement: Scalars['Boolean']['input'];
  Prefecture: Scalars['String']['input'];
  Profession: Scalars['Int']['input'];
  ResidenceConfirmation: Scalars['Boolean']['input'];
  RetirementDate?: InputMaybe<Scalars['String']['input']>;
  SSN?: InputMaybe<Scalars['String']['input']>;
  SecuritiesTradingTermsAgreement: Scalars['Boolean']['input'];
  Sex: Scalars['Int']['input'];
  TownStreetAddress?: InputMaybe<Scalars['String']['input']>;
  WorkPhoneNumber: Scalars['String']['input'];
  Workplace: Scalars['String']['input'];
};

export type Query = {
  __typename?: 'Query';
  GetAccountDetailInfo?: Maybe<AccountDetailInfo>;
  GetAccountInfo?: Maybe<AccountInfo>;
  GetAddressInfo?: Maybe<AddressInfo>;
  GetAgreementDocument?: Maybe<AgreementDocumentList>;
  GetAgreementDocumentList?: Maybe<AgreementDocumentList>;
  GetApplicationInfo?: Maybe<ApplicationDetailInfo>;
  GetApplicationList?: Maybe<ApplicationList>;
  GetBrokerMaster?: Maybe<BrokerInfo>;
  GetDateTime?: Maybe<DateTimeInfo>;
  GetIssuanceDocument?: Maybe<IssuanceDocument>;
  GetIssuanceDocumentList?: Maybe<IssuanceDocumentList>;
  GetNotificationInfo?: Maybe<NotificationDetailInfo>;
  GetNotificationList?: Maybe<NotificationList>;
  GetSymbolInfo?: Maybe<SymbolDetailInfo>;
  GetSymbolList?: Maybe<SymbolList>;
};


export type QueryGetAddressInfoArgs = {
  postCode: Scalars['String']['input'];
};


export type QueryGetApplicationInfoArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetApplicationListArgs = {
  count: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
  symbolName?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetBrokerMasterArgs = {
  branchCode: Scalars['String']['input'];
  brokerCode: Scalars['String']['input'];
};


export type QueryGetIssuanceDocumentArgs = {
  id: Scalars['String']['input'];
};


export type QueryGetIssuanceDocumentListArgs = {
  count: Scalars['Int']['input'];
  documentType?: InputMaybe<Scalars['Int']['input']>;
  page: Scalars['Int']['input'];
};


export type QueryGetNotificationInfoArgs = {
  id: Scalars['String']['input'];
};


export type QueryGetNotificationListArgs = {
  count: Scalars['Int']['input'];
  deliveryTarget?: InputMaybe<Scalars['Int']['input']>;
  onlyNotConfirmed?: InputMaybe<Scalars['Boolean']['input']>;
  page: Scalars['Int']['input'];
};


export type QueryGetSymbolInfoArgs = {
  symbol?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetSymbolListArgs = {
  count: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
  symbolName?: InputMaybe<Scalars['String']['input']>;
};

export type ReadNotificationParam = {
  ID?: InputMaybe<Scalars['String']['input']>;
};

export type ReissuePasswordParam = {
  Account: Scalars['String']['input'];
  PhoneNumber: Scalars['String']['input'];
};

export type ReissuePasswordResult = {
  __typename?: 'ReissuePasswordResult';
  Code: Scalars['Int']['output'];
  Message?: Maybe<Scalars['String']['output']>;
  ProvisionalToken?: Maybe<Scalars['String']['output']>;
};

export type SmsCertificateParam = {
  AuthenticationCode: Scalars['String']['input'];
  ProvisionalToken: Scalars['String']['input'];
  Type: Scalars['Int']['input'];
};

export type SmsCertificateResult = {
  __typename?: 'SMSCertificateResult';
  Code: Scalars['Int']['output'];
  Message?: Maybe<Scalars['String']['output']>;
  Token?: Maybe<Scalars['String']['output']>;
};

export type SendSmsParam = {
  Account?: InputMaybe<Scalars['String']['input']>;
  PhoneNumber?: InputMaybe<Scalars['String']['input']>;
  ProvisionalToken?: InputMaybe<Scalars['String']['input']>;
  Type: Scalars['Int']['input'];
};

export type SendSmsResult = {
  __typename?: 'SendSMSResult';
  Code: Scalars['Int']['output'];
  Message?: Maybe<Scalars['String']['output']>;
  ProvisionalToken?: Maybe<Scalars['String']['output']>;
};

export type SymbolDetailInfo = {
  __typename?: 'SymbolDetailInfo';
  CurrentPrice: Scalars['Float']['output'];
  ExpectedInterestRate: Scalars['Float']['output'];
  Explanation: Scalars['String']['output'];
  ImageUrl: Scalars['String']['output'];
  OperationEndDate: Scalars['String']['output'];
  OperationStartDate: Scalars['String']['output'];
  Overview: Scalars['String']['output'];
  PreContractDocumentUrl: Scalars['String']['output'];
  PricePerUnit: Scalars['Float']['output'];
  ProspectusUrl: Scalars['String']['output'];
  Symbol: Scalars['String']['output'];
  SymbolName: Scalars['String']['output'];
  Tradable?: Maybe<Scalars['Boolean']['output']>;
  TradeEndDate: Scalars['String']['output'];
  TradeStartDate: Scalars['String']['output'];
};

export type SymbolInfo = {
  __typename?: 'SymbolInfo';
  CurrentPrice: Scalars['Float']['output'];
  ExpectedInterestRate: Scalars['Float']['output'];
  ImageUrl: Scalars['String']['output'];
  OperationEndDate: Scalars['String']['output'];
  OperationStartDate: Scalars['String']['output'];
  Overview: Scalars['String']['output'];
  PricePerUnit: Scalars['Float']['output'];
  Symbol: Scalars['String']['output'];
  SymbolName: Scalars['String']['output'];
  Tradable?: Maybe<Scalars['Boolean']['output']>;
  TradeEndDate: Scalars['String']['output'];
  TradeStartDate: Scalars['String']['output'];
};

export type SymbolList = {
  __typename?: 'SymbolList';
  Data?: Maybe<Array<Maybe<SymbolInfo>>>;
  TotalCount: Scalars['Int']['output'];
};

export type LoginMutationVariables = Exact<{
  input?: InputMaybe<LoginParam>;
}>;


export type LoginMutation = { __typename?: 'Mutation', Login?: { __typename?: 'LoginResult', Code: number, Message?: string | null, ProvisionalToken?: string | null, PhoneNumber?: string | null } | null };

export type LogoutMutationVariables = Exact<{ [key: string]: never; }>;


export type LogoutMutation = { __typename?: 'Mutation', Logout?: { __typename?: 'ExecuteResult', Code: number, Message?: string | null } | null };

export type ReadNotificationMutationVariables = Exact<{
  input?: InputMaybe<ReadNotificationParam>;
}>;


export type ReadNotificationMutation = { __typename?: 'Mutation', ReadNotification?: { __typename?: 'ExecuteResult', Code: number, Message?: string | null } | null };

export type SmsCertificateMutationVariables = Exact<{
  input?: InputMaybe<SmsCertificateParam>;
}>;


export type SmsCertificateMutation = { __typename?: 'Mutation', SMSCertificate?: { __typename?: 'SMSCertificateResult', Code: number, Message?: string | null, Token?: string | null } | null };

export type SendSmsMutationVariables = Exact<{
  input?: InputMaybe<SendSmsParam>;
}>;


export type SendSmsMutation = { __typename?: 'Mutation', SendSMS?: { __typename?: 'SendSMSResult', Code: number, Message?: string | null, ProvisionalToken?: string | null } | null };

export type GetSymbolListQueryVariables = Exact<{
  count: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
  symbolName?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetSymbolListQuery = { __typename?: 'Query', GetSymbolList?: { __typename?: 'SymbolList', TotalCount: number, Data?: Array<{ __typename?: 'SymbolInfo', Symbol: string, SymbolName: string, ImageUrl: string, Overview: string, CurrentPrice: number, PricePerUnit: number, ExpectedInterestRate: number, OperationStartDate: string, OperationEndDate: string, Tradable?: boolean | null, TradeStartDate: string, TradeEndDate: string } | null> | null } | null };

export type GetSymbolInfoQueryVariables = Exact<{
  symbol?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetSymbolInfoQuery = { __typename?: 'Query', GetSymbolInfo?: { __typename?: 'SymbolDetailInfo', Symbol: string, SymbolName: string, ImageUrl: string, Overview: string, Explanation: string, CurrentPrice: number, PricePerUnit: number, ExpectedInterestRate: number, ProspectusUrl: string, PreContractDocumentUrl: string, OperationStartDate: string, OperationEndDate: string, Tradable?: boolean | null, TradeStartDate: string, TradeEndDate: string } | null };

export type ApplySymbolMutationVariables = Exact<{
  input?: InputMaybe<ApplySymbolParam>;
}>;


export type ApplySymbolMutation = { __typename?: 'Mutation', ApplySymbol?: { __typename?: 'ExecuteResult', Code: number, Message?: string | null, AdditionalMessage?: Array<string | null> | null } | null };

export type OpenAccountMutationVariables = Exact<{
  input?: InputMaybe<OpenAccountParam>;
}>;


export type OpenAccountMutation = { __typename?: 'Mutation', OpenAccount?: { __typename?: 'ExecuteResult', Code: number, Message?: string | null } | null };

export type GetApplicationListQueryVariables = Exact<{
  count: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
  symbolName?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetApplicationListQuery = { __typename?: 'Query', GetApplicationList?: { __typename?: 'ApplicationList', TotalCount: number, Data?: Array<{ __typename?: 'ApplicationInfo', ID: string, LatestApplicationDateTime: string, Status: number, Symbol: string, SymbolName: string, TotalApplicationQuantity: number, TotalPurchaseQuantity: number } | null> | null } | null };

export type GetApplicationInfoQueryVariables = Exact<{
  id?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetApplicationInfoQuery = { __typename?: 'Query', GetApplicationInfo?: { __typename?: 'ApplicationDetailInfo', ID: string, LatestApplicationDateTime: string, Status: number, Symbol: string, SymbolName: string, TotalApplicationQuantity: number, TotalPurchaseQuantity: number } | null };

export type GetNotificationListQueryVariables = Exact<{
  count: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
  deliveryTarget?: InputMaybe<Scalars['Int']['input']>;
  onlyNotConfirmed?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetNotificationListQuery = { __typename?: 'Query', GetNotificationList?: { __typename?: 'NotificationList', TotalCount: number, Data?: Array<{ __typename?: 'NotificationInfo', Confirmed?: boolean | null, DeliveryTarget: number, DeliveryType: number, ID: string, PublishStartDate: string, Title: string } | null> | null } | null };

export type GetAddressInfoQueryVariables = Exact<{
  postCode: Scalars['String']['input'];
}>;


export type GetAddressInfoQuery = { __typename?: 'Query', GetAddressInfo?: { __typename?: 'AddressInfo', CityCounty?: string | null, Prefecture?: string | null, TownStreetAddress?: string | null } | null };

export type GetNotificationInfoQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetNotificationInfoQuery = { __typename?: 'Query', GetNotificationInfo?: { __typename?: 'NotificationDetailInfo', ConfirmDateTime?: string | null, Confirmed?: boolean | null, Contents: string, DeliveryTarget: number, DeliveryType: number, ID: string, PublishStartDate: string, Title: string } | null };

export type GetIssuanceDocumentListQueryVariables = Exact<{
  count: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
  documentType?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetIssuanceDocumentListQuery = { __typename?: 'Query', GetIssuanceDocumentList?: { __typename?: 'IssuanceDocumentList', TotalCount: number, Data?: Array<{ __typename?: 'IssuanceDocumentInfo', DisplayName: string, FileName: string, ID: string, IssueDate: string } | null> | null } | null };

export type GetIssuanceDocumentQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetIssuanceDocumentQuery = { __typename?: 'Query', GetIssuanceDocument?: { __typename?: 'IssuanceDocument', Data: string } | null };

export type GetBrokerMasterQueryVariables = Exact<{
  brokerCode: Scalars['String']['input'];
  branchCode: Scalars['String']['input'];
}>;


export type GetBrokerMasterQuery = { __typename?: 'Query', GetBrokerMaster?: { __typename?: 'BrokerInfo', BranchCode?: string | null, BranchName?: string | null, BrokerCode?: string | null, BrokerName?: string | null } | null };

export type GetAccountDetailInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAccountDetailInfoQuery = { __typename?: 'Query', GetAccountDetailInfo?: { __typename?: 'AccountDetailInfo', AccountNumber: string, AmericanOnTaxSystem?: boolean | null, AnnualIncome: number, BankCode: string, Birthday?: string | null, BranchCode: string, BuildingNameRoomNumber?: string | null, CityCounty: string, Department?: string | null, DepositForm: number, FATCAAgreement?: boolean | null, FATCAOath?: boolean | null, FinancialAssets: number, FirstName: string, FirstNameKana: string, HomePhoneNumber?: string | null, ITIN?: string | null, IncomeForm: Array<number | null>, InsiderBoardMemberFirstName?: string | null, InsiderBoardMemberLastName?: string | null, InvestmentExperiences: Array<number | null>, InvestmentPolicy: number, InvestmentPurposes: Array<number | null>, LastName: string, LastNameKana: string, ListedCompanyCheck: boolean, ListedCompanyName?: string | null, ListedCompanyPost?: number | null, MailAddress?: string | null, MobilePhoneNumber: string, Nationality: number, OutSidePost?: string | null, Post?: string | null, PostCode: string, Prefecture: string, Profession: number, RetirementDate?: string | null, SSN?: string | null, Sex?: number | null, TownStreetAddress?: string | null, WorkPhoneNumber?: string | null, Workplace?: string | null } | null };

export type ChangeAccountInfoMutationVariables = Exact<{
  input?: InputMaybe<ChangeAccountInfoParam>;
}>;


export type ChangeAccountInfoMutation = { __typename?: 'Mutation', ChangeAccountInfo?: { __typename?: 'ChangeAccountInfoResult', Code: number, Message?: string | null, WithEKYC?: boolean | null } | null };

export type InquiryMutationVariables = Exact<{
  input?: InputMaybe<InquiryParam>;
}>;


export type InquiryMutation = { __typename?: 'Mutation', Inquiry?: { __typename?: 'ExecuteResult', Code: number, Message?: string | null } | null };

export type GetAccountInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAccountInfoQuery = { __typename?: 'Query', GetAccountInfo?: { __typename?: 'AccountInfo', Account: string, ChangedPassword: boolean, DepositAmount: string, LastLoginDateTime?: string | null, MarginAmount: string } | null };

export type ReissuePasswordMutationVariables = Exact<{
  input?: InputMaybe<ReissuePasswordParam>;
}>;


export type ReissuePasswordMutation = { __typename?: 'Mutation', ReissuePassword?: { __typename?: 'ReissuePasswordResult', Code: number, Message?: string | null, ProvisionalToken?: string | null } | null };

export type AgreeDocumentMutationVariables = Exact<{
  input?: InputMaybe<AgreeDocumentParam>;
}>;


export type AgreeDocumentMutation = { __typename?: 'Mutation', AgreeDocument?: { __typename?: 'ExecuteResult', Code: number, Message?: string | null } | null };

export type GetAgreementDocumentQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAgreementDocumentQuery = { __typename?: 'Query', GetAgreementDocument?: { __typename?: 'AgreementDocumentList', Data?: Array<{ __typename?: 'AgreementDocumentInfo', Read: boolean, Type: number, URL: string } | null> | null } | null };

export type GetDateTimeQueryVariables = Exact<{ [key: string]: never; }>;


export type GetDateTimeQuery = { __typename?: 'Query', GetDateTime?: { __typename?: 'DateTimeInfo', Current?: string | null } | null };

export type GetAgreementDocumentListQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAgreementDocumentListQuery = { __typename?: 'Query', GetAgreementDocumentList?: { __typename?: 'AgreementDocumentList', Data?: Array<{ __typename?: 'AgreementDocumentInfo', Type: number, URL: string } | null> | null } | null };

export type ChangePasswordMutationVariables = Exact<{
  input?: InputMaybe<ChangePasswordParam>;
}>;


export type ChangePasswordMutation = { __typename?: 'Mutation', ChangePassword?: { __typename?: 'ExecuteResult', Code: number, Message?: string | null } | null };


export const LoginDocument = gql`
    mutation Login($input: LoginParam) {
  Login(input: $input) {
    Code
    Message
    ProvisionalToken
    PhoneNumber
  }
}
    `;

export function useLoginMutation() {
  return Urql.useMutation<LoginMutation, LoginMutationVariables>(LoginDocument);
};
export const LogoutDocument = gql`
    mutation Logout {
  Logout {
    Code
    Message
  }
}
    `;

export function useLogoutMutation() {
  return Urql.useMutation<LogoutMutation, LogoutMutationVariables>(LogoutDocument);
};
export const ReadNotificationDocument = gql`
    mutation ReadNotification($input: ReadNotificationParam) {
  ReadNotification(input: $input) {
    Code
    Message
  }
}
    `;

export function useReadNotificationMutation() {
  return Urql.useMutation<ReadNotificationMutation, ReadNotificationMutationVariables>(ReadNotificationDocument);
};
export const SmsCertificateDocument = gql`
    mutation SMSCertificate($input: SMSCertificateParam) {
  SMSCertificate(input: $input) {
    Code
    Message
    Token
  }
}
    `;

export function useSmsCertificateMutation() {
  return Urql.useMutation<SmsCertificateMutation, SmsCertificateMutationVariables>(SmsCertificateDocument);
};
export const SendSmsDocument = gql`
    mutation SendSMS($input: SendSMSParam) {
  SendSMS(input: $input) {
    Code
    Message
    ProvisionalToken
  }
}
    `;

export function useSendSmsMutation() {
  return Urql.useMutation<SendSmsMutation, SendSmsMutationVariables>(SendSmsDocument);
};
export const GetSymbolListDocument = gql`
    query GetSymbolList($count: Int!, $page: Int!, $symbolName: String) {
  GetSymbolList(count: $count, page: $page, symbolName: $symbolName) {
    TotalCount
    Data {
      Symbol
      SymbolName
      ImageUrl
      Overview
      CurrentPrice
      PricePerUnit
      ExpectedInterestRate
      OperationStartDate
      OperationEndDate
      Tradable
      TradeStartDate
      TradeEndDate
    }
  }
}
    `;

export function useGetSymbolListQuery(options: Omit<Urql.UseQueryArgs<GetSymbolListQueryVariables>, 'query'>) {
  return Urql.useQuery<GetSymbolListQuery, GetSymbolListQueryVariables>({ query: GetSymbolListDocument, ...options });
};
export const GetSymbolInfoDocument = gql`
    query GetSymbolInfo($symbol: String) {
  GetSymbolInfo(symbol: $symbol) {
    Symbol
    SymbolName
    ImageUrl
    Overview
    Explanation
    CurrentPrice
    PricePerUnit
    ExpectedInterestRate
    ProspectusUrl
    PreContractDocumentUrl
    OperationStartDate
    OperationEndDate
    Tradable
    TradeStartDate
    TradeEndDate
  }
}
    `;

export function useGetSymbolInfoQuery(options?: Omit<Urql.UseQueryArgs<GetSymbolInfoQueryVariables>, 'query'>) {
  return Urql.useQuery<GetSymbolInfoQuery, GetSymbolInfoQueryVariables>({ query: GetSymbolInfoDocument, ...options });
};
export const ApplySymbolDocument = gql`
    mutation ApplySymbol($input: ApplySymbolParam) {
  ApplySymbol(input: $input) {
    Code
    Message
    AdditionalMessage
  }
}
    `;

export function useApplySymbolMutation() {
  return Urql.useMutation<ApplySymbolMutation, ApplySymbolMutationVariables>(ApplySymbolDocument);
};
export const OpenAccountDocument = gql`
    mutation OpenAccount($input: OpenAccountParam) {
  OpenAccount(input: $input) {
    Code
    Message
  }
}
    `;

export function useOpenAccountMutation() {
  return Urql.useMutation<OpenAccountMutation, OpenAccountMutationVariables>(OpenAccountDocument);
};
export const GetApplicationListDocument = gql`
    query GetApplicationList($count: Int!, $page: Int!, $symbolName: String) {
  GetApplicationList(count: $count, page: $page, symbolName: $symbolName) {
    TotalCount
    Data {
      ID
      LatestApplicationDateTime
      Status
      Symbol
      SymbolName
      TotalApplicationQuantity
      TotalPurchaseQuantity
    }
  }
}
    `;

export function useGetApplicationListQuery(options: Omit<Urql.UseQueryArgs<GetApplicationListQueryVariables>, 'query'>) {
  return Urql.useQuery<GetApplicationListQuery, GetApplicationListQueryVariables>({ query: GetApplicationListDocument, ...options });
};
export const GetApplicationInfoDocument = gql`
    query GetApplicationInfo($id: String) {
  GetApplicationInfo(id: $id) {
    ID
    LatestApplicationDateTime
    Status
    Symbol
    SymbolName
    TotalApplicationQuantity
    TotalPurchaseQuantity
  }
}
    `;

export function useGetApplicationInfoQuery(options?: Omit<Urql.UseQueryArgs<GetApplicationInfoQueryVariables>, 'query'>) {
  return Urql.useQuery<GetApplicationInfoQuery, GetApplicationInfoQueryVariables>({ query: GetApplicationInfoDocument, ...options });
};
export const GetNotificationListDocument = gql`
    query GetNotificationList($count: Int!, $page: Int!, $deliveryTarget: Int, $onlyNotConfirmed: Boolean) {
  GetNotificationList(
    count: $count
    page: $page
    deliveryTarget: $deliveryTarget
    onlyNotConfirmed: $onlyNotConfirmed
  ) {
    TotalCount
    Data {
      Confirmed
      DeliveryTarget
      DeliveryType
      ID
      PublishStartDate
      Title
    }
  }
}
    `;

export function useGetNotificationListQuery(options: Omit<Urql.UseQueryArgs<GetNotificationListQueryVariables>, 'query'>) {
  return Urql.useQuery<GetNotificationListQuery, GetNotificationListQueryVariables>({ query: GetNotificationListDocument, ...options });
};
export const GetAddressInfoDocument = gql`
    query GetAddressInfo($postCode: String!) {
  GetAddressInfo(postCode: $postCode) {
    CityCounty
    Prefecture
    TownStreetAddress
  }
}
    `;

export function useGetAddressInfoQuery(options: Omit<Urql.UseQueryArgs<GetAddressInfoQueryVariables>, 'query'>) {
  return Urql.useQuery<GetAddressInfoQuery, GetAddressInfoQueryVariables>({ query: GetAddressInfoDocument, ...options });
};
export const GetNotificationInfoDocument = gql`
    query GetNotificationInfo($id: String!) {
  GetNotificationInfo(id: $id) {
    ConfirmDateTime
    Confirmed
    Contents
    DeliveryTarget
    DeliveryType
    ID
    PublishStartDate
    Title
  }
}
    `;

export function useGetNotificationInfoQuery(options: Omit<Urql.UseQueryArgs<GetNotificationInfoQueryVariables>, 'query'>) {
  return Urql.useQuery<GetNotificationInfoQuery, GetNotificationInfoQueryVariables>({ query: GetNotificationInfoDocument, ...options });
};
export const GetIssuanceDocumentListDocument = gql`
    query GetIssuanceDocumentList($count: Int!, $page: Int!, $documentType: Int) {
  GetIssuanceDocumentList(count: $count, page: $page, documentType: $documentType) {
    TotalCount
    Data {
      DisplayName
      FileName
      ID
      IssueDate
    }
  }
}
    `;

export function useGetIssuanceDocumentListQuery(options: Omit<Urql.UseQueryArgs<GetIssuanceDocumentListQueryVariables>, 'query'>) {
  return Urql.useQuery<GetIssuanceDocumentListQuery, GetIssuanceDocumentListQueryVariables>({ query: GetIssuanceDocumentListDocument, ...options });
};
export const GetIssuanceDocumentDocument = gql`
    query GetIssuanceDocument($id: String!) {
  GetIssuanceDocument(id: $id) {
    Data
  }
}
    `;

export function useGetIssuanceDocumentQuery(options: Omit<Urql.UseQueryArgs<GetIssuanceDocumentQueryVariables>, 'query'>) {
  return Urql.useQuery<GetIssuanceDocumentQuery, GetIssuanceDocumentQueryVariables>({ query: GetIssuanceDocumentDocument, ...options });
};
export const GetBrokerMasterDocument = gql`
    query GetBrokerMaster($brokerCode: String!, $branchCode: String!) {
  GetBrokerMaster(brokerCode: $brokerCode, branchCode: $branchCode) {
    BranchCode
    BranchName
    BrokerCode
    BrokerName
  }
}
    `;

export function useGetBrokerMasterQuery(options: Omit<Urql.UseQueryArgs<GetBrokerMasterQueryVariables>, 'query'>) {
  return Urql.useQuery<GetBrokerMasterQuery, GetBrokerMasterQueryVariables>({ query: GetBrokerMasterDocument, ...options });
};
export const GetAccountDetailInfoDocument = gql`
    query GetAccountDetailInfo {
  GetAccountDetailInfo {
    AccountNumber
    AmericanOnTaxSystem
    AnnualIncome
    BankCode
    Birthday
    BranchCode
    BuildingNameRoomNumber
    CityCounty
    Department
    DepositForm
    FATCAAgreement
    FATCAOath
    FinancialAssets
    FirstName
    FirstNameKana
    HomePhoneNumber
    ITIN
    IncomeForm
    InsiderBoardMemberFirstName
    InsiderBoardMemberLastName
    InvestmentExperiences
    InvestmentPolicy
    InvestmentPurposes
    LastName
    LastNameKana
    ListedCompanyCheck
    ListedCompanyName
    ListedCompanyPost
    MailAddress
    MobilePhoneNumber
    Nationality
    OutSidePost
    Post
    PostCode
    Prefecture
    Profession
    RetirementDate
    SSN
    Sex
    TownStreetAddress
    WorkPhoneNumber
    Workplace
  }
}
    `;

export function useGetAccountDetailInfoQuery(options?: Omit<Urql.UseQueryArgs<GetAccountDetailInfoQueryVariables>, 'query'>) {
  return Urql.useQuery<GetAccountDetailInfoQuery, GetAccountDetailInfoQueryVariables>({ query: GetAccountDetailInfoDocument, ...options });
};
export const ChangeAccountInfoDocument = gql`
    mutation ChangeAccountInfo($input: ChangeAccountInfoParam) {
  ChangeAccountInfo(input: $input) {
    Code
    Message
    WithEKYC
  }
}
    `;

export function useChangeAccountInfoMutation() {
  return Urql.useMutation<ChangeAccountInfoMutation, ChangeAccountInfoMutationVariables>(ChangeAccountInfoDocument);
};
export const InquiryDocument = gql`
    mutation Inquiry($input: InquiryParam) {
  Inquiry(input: $input) {
    Code
    Message
  }
}
    `;

export function useInquiryMutation() {
  return Urql.useMutation<InquiryMutation, InquiryMutationVariables>(InquiryDocument);
};
export const GetAccountInfoDocument = gql`
    query GetAccountInfo {
  GetAccountInfo {
    Account
    ChangedPassword
    DepositAmount
    LastLoginDateTime
    MarginAmount
  }
}
    `;

export function useGetAccountInfoQuery(options?: Omit<Urql.UseQueryArgs<GetAccountInfoQueryVariables>, 'query'>) {
  return Urql.useQuery<GetAccountInfoQuery, GetAccountInfoQueryVariables>({ query: GetAccountInfoDocument, ...options });
};
export const ReissuePasswordDocument = gql`
    mutation ReissuePassword($input: ReissuePasswordParam) {
  ReissuePassword(input: $input) {
    Code
    Message
    ProvisionalToken
  }
}
    `;

export function useReissuePasswordMutation() {
  return Urql.useMutation<ReissuePasswordMutation, ReissuePasswordMutationVariables>(ReissuePasswordDocument);
};
export const AgreeDocumentDocument = gql`
    mutation AgreeDocument($input: AgreeDocumentParam) {
  AgreeDocument(input: $input) {
    Code
    Message
  }
}
    `;

export function useAgreeDocumentMutation() {
  return Urql.useMutation<AgreeDocumentMutation, AgreeDocumentMutationVariables>(AgreeDocumentDocument);
};
export const GetAgreementDocumentDocument = gql`
    query GetAgreementDocument {
  GetAgreementDocument {
    Data {
      Read
      Type
      URL
    }
  }
}
    `;

export function useGetAgreementDocumentQuery(options?: Omit<Urql.UseQueryArgs<GetAgreementDocumentQueryVariables>, 'query'>) {
  return Urql.useQuery<GetAgreementDocumentQuery, GetAgreementDocumentQueryVariables>({ query: GetAgreementDocumentDocument, ...options });
};
export const GetDateTimeDocument = gql`
    query GetDateTime {
  GetDateTime {
    Current
  }
}
    `;

export function useGetDateTimeQuery(options?: Omit<Urql.UseQueryArgs<GetDateTimeQueryVariables>, 'query'>) {
  return Urql.useQuery<GetDateTimeQuery, GetDateTimeQueryVariables>({ query: GetDateTimeDocument, ...options });
};
export const GetAgreementDocumentListDocument = gql`
    query GetAgreementDocumentList {
  GetAgreementDocumentList {
    Data {
      Type
      URL
    }
  }
}
    `;

export function useGetAgreementDocumentListQuery(options?: Omit<Urql.UseQueryArgs<GetAgreementDocumentListQueryVariables>, 'query'>) {
  return Urql.useQuery<GetAgreementDocumentListQuery, GetAgreementDocumentListQueryVariables>({ query: GetAgreementDocumentListDocument, ...options });
};
export const ChangePasswordDocument = gql`
    mutation ChangePassword($input: ChangePasswordParam) {
  ChangePassword(input: $input) {
    Code
    Message
  }
}
    `;

export function useChangePasswordMutation() {
  return Urql.useMutation<ChangePasswordMutation, ChangePasswordMutationVariables>(ChangePasswordDocument);
};